import '../../legend.css';
import '../../main.css';
import '../../main-desktop.css';
import '../../icons.css';

import './briefing.css';

// ! Bootstrap icons
import "bootstrap-icons/font/bootstrap-icons.css";

// XML to JS
// import xmlToJsonConverter from 'xml-js';

import {
    authClient
} from '../../okta-auth';

import {
    GEOSERVER_URL,
    INCORRECT_GEOSERVER_URL
} from '../../env';

// ESRI
import Map from '@arcgis/core/Map.js'
import MapView from '@arcgis/core/views/MapView.js'
import TimeSlider from "@arcgis/core/widgets/TimeSlider.js";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils.js"
import WMSLayer from "@arcgis/core/layers/WMSLayer";
import TimeExtent from "@arcgis/core/TimeExtent.js";
import PictureMarkerSymbol from "@arcgis/core/symbols/PictureMarkerSymbol.js";
import Point from "@arcgis/core/geometry/Point.js";
import Graphic from "@arcgis/core/Graphic.js";
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import esriConfig from "@arcgis/core/config.js";

// Layer manager
// import * as LayerManager from '../../layer-manager';

// Navbar
import {
    closeNavbar,
    attachDropdownListeners
} from '../navbar/navbar';

import '../navbar/navbar';
import bootstrapBundleMin from '../../../public/lib/js/bootstrap.bundle.min';

// ! Popup template

import {
    popupTemplate
} from '../../queries/popup-templates/incident-popup-template';

// ! GLOBAL VARIABLES
const dateStringOptions = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hourCycle: 'h23',
    timeZoneName: "short"
};

// Incidents refresh once every 2 minutes
const incidentRefreshTimeout = 2 * 60 * 1000;
const numMaps = 4;
var map1, map2, map3, map4;
var map1View, map2View, map3View, map4View;
var incid1, incid2, incid3, incid4;
var timeSlider;

const rasterLayers = [
    {   
        layerName: 'Temperature',
        layerValue: 'IDZ71000_AUS_T_SFC',
        layerType: 'Forecast_WMS',
        timeSteps: [],
        timeStepInterval: "" // 'Daily' or 'Hourly'
    },
    {
        layerName: 'Relative Humidity',
        layerValue: 'IDZ71018_AUS_RH_SFC',
        layerType: 'Forecast_WMS',
        timeSteps: [],
        timeStepInterval: ""
    },
    {
        layerName: 'Fire Danger Rating',
        layerValue: 'IDZ10134_AUS_AFDRS_fdr_SFC',
        layerType: 'Forecast_WMS',
        timeSteps: [],
        timeStepInterval: ""
    },
    {
        layerName: 'Fire Behaviour Index',
        layerValue: 'IDZ10135_AUS_AFDRS_fbi_SFC',
        layerType: 'Forecast_WMS',
        timeSteps: [],
        timeStepInterval: ""
    },
    {
        layerName: 'Dewpoint Temperature',
        layerValue: 'IDZ71001_AUS_Td_SFC',
        layerType: 'Forecast_WMS',
        timeSteps: [],
        timeStepInterval: ""
    },
    {
        layerName: 'Continuous Haines',
        layerValue: 'IDZ71115_AUS_CHaines_SFC',
        layerType: 'Forecast_WMS',
        timeSteps: [],
        timeStepInterval: ""
    },
    {
        layerName: 'Lightning Activity Level',
        layerValue: 'IDZ71114_AUS_LAL2_SFC',
        layerType: 'Forecast_WMS',
        timeSteps: [],
        timeStepInterval: ""
    },
    {
        layerName: 'Drought Factor',
        layerValue: 'IDZ71127_AUS_DF_SFC',
        layerType: 'Forecast_WMS',
        timeSteps: [],
        timeStepInterval: ""
    },
    {
        layerName: 'Wind Magnitude and Direction',
        layerValue: 'IDZ71071_AUS_WindMagKmh_SFC',
        layerType: 'Forecast_WMS',
        timeSteps: [],
        timeStepInterval: ""
    },
    {
        layerName: 'WindMagDir1500',
        layerValue: 'IDZ71110_AUS_WindMagKmh_1500mAMSL',
        layerType: 'Forecast_WMS',
        timeSteps: [],
        timeStepInterval: ""
    },
    {
        layerName: 'Mixing Height',
        layerValue: 'IDZ71109_AUS_MixHgt_SFC',
        layerType: 'Forecast_WMS',
        timeSteps: [],
        timeStepInterval: ""
    },
    {
        layerName: 'Prescribed Burning',
        layerValue: 'RFS_PBFT_SFC',
        layerType: 'Forecast_WMS',
        timeSteps: [],
        timeStepInterval: ""
    }
];

/**
 * Creates a new `WMSLayer` object and returns it
 * @param layerName : The name of the raster layer to use 
 */
function createWmsLayer(layerName, startDate = undefined) {
    const layerObj = rasterLayers.find(e => e.layerName === layerName);

    if(!layerObj) {
        console.error(`Unknown layerName : ${layerName}`);
        return;
    }

    const sublayer = `fireweather:${layerObj.layerValue}`;

    const timeExtent = startDate ? new TimeExtent({
        start: new Date(startDate),
        end: new Date(startDate)
    }) : null

    // Get the access token
    const { 
        idToken, 
        accessToken, 
        refreshToken } = authClient.tokenManager.getTokensSync();
    
    // Hacky fix that bypasses esri/request's `GetCapabilities` resolution.
    const matchGeoserverUrl = GEOSERVER_URL.match(/^(.*?\/geoserver\/)/);
    const geoserverBaseUrl = matchGeoserverUrl ? matchGeoserverUrl[1] : GEOSERVER_URL;
    esriConfig.request.interceptors.push({
        urls: [geoserverBaseUrl, INCORRECT_GEOSERVER_URL],

        headers: {
            Authorization: 'Bearer ' + accessToken.accessToken
        },
        // change request before it is sent
        before: function(params) {
            // Replaces the incorrect geoserver url with the correct one
            if (params.url.includes(INCORRECT_GEOSERVER_URL)) {
                params.url = params.url.replace(
                    INCORRECT_GEOSERVER_URL, 
                    GEOSERVER_URL); 
            }
        }
    });

    const newLayer = new WMSLayer({
        id: `${layerObj.layerValue}`,
        url: GEOSERVER_URL,
        opacity: 0.7,
        sublayers: [{
            name: sublayer
        }],
        timeExtent: timeExtent
    });

    return newLayer;
}

/**
 * Sets the header value of the map cells
 * e.g. Temperature : Tuesday, April 30, 2024 at 06:00 GMT+10
 */
function setMapHeaderValues(rasterLayer, timestep, mapIndex) {
    const dateStr = timestep.toLocaleDateString('en-US', dateStringOptions)

    $(`#map${mapIndex+1}-header`).html(
        `<span class="map-cell-header-layer-name">${rasterLayer.layerName} :</span>` + 
        `<span class="map-cell-header-time-info">${dateStr}</span>`
    )
}

/**
 * Sets the step size of the timeslider to either `hourly` or `daily`
 */
function setTimesliderStepSize(mode) {
    switch(mode) {
        case 'hourly':
            timeSlider.stops = {
                interval: {
                    value: 1,
                    unit: "hours"
                  }
            }
            break;
        case 'daily':
            timeSlider.stops = {
                interval: {
                    value: 1,
                    unit: "days"
                  }
            }
            break;
        default:
            console.error(`Unknown timeslider step size setting : ${mode}`);
    }
}

function attachModalBtnListeners() {
    const doneBtn = $(`#modal-done-btn-id`);
    const hourlyBtn = $(`#modal-hourly-btn-id`);
    const dailyBtn = $(`#modal-daily-btn-id`);

    const timesliderActive = "timeslider-settings-btn-style-active";
    const timesliderInactive = "timeslider-settings-btn-style";

    // Handlers for the open and close buttons
    doneBtn.on("click", function() {
        const activeModal = $('#brief-settings-modal-id');
        
        // Hide the modal
        activeModal.modal('hide');
    });

    hourlyBtn.on("click", function() {
        setTimesliderStepSize('hourly');
        // Remove the `inactive` class from the hourly btn
        hourlyBtn.removeClass(timesliderInactive);
        hourlyBtn.addClass(timesliderActive);

        // Remove the `active` class from the daily btn
        dailyBtn.removeClass(timesliderActive);
        dailyBtn.addClass(timesliderInactive);
    });

    dailyBtn.on("click", function() {
        setTimesliderStepSize('daily');
        // Remove the `inactive` class from the hourly btn
        hourlyBtn.removeClass(timesliderActive);
        hourlyBtn.addClass(timesliderInactive);

        // Remove the `active` class from the daily btn
        dailyBtn.removeClass(timesliderInactive);
        dailyBtn.addClass(timesliderActive);
    })
}

/**
 * Simple function to get the map based on a specific index.
 * This was done to prevent a race condition where storing the maps
 * as a list sometimes stores a reference to undefined.
 * @param {*} index the map we want to get
 * @returns The map that corresponds to the index. Otherwise returns undefined.
 */
function getMap(index) {
    switch(index) {
        case 0:
            return map1;
        case 1:
            return map2;
        case 2:
            return map3;
        case 3:
            return map4;
        default:
            console.error(`Unknown map index : ${index}`);
    }
}

function getIncidentGraphicsLayer(index) {
    switch(index) {
        case 0:
            return incid1;
        case 1:
            return incid2;
        case 2:
            return incid3;
        case 3:
            return incid4;
        default:
            console.error(`Unknown mapView index : ${index}`);
    }
}

function getMapView(index) {
    switch(index) {
        case 0:
            return map1View;
        case 1:
            return map2View;
        case 2:
            return map3View;
        case 3:
            return map4View;
        default:
            console.error(`Unknown mapView index : ${index}`);
    }
}

/**
 * Generates the dropdowns for the settings modal
 * 
 */
function generateModalDropdowns() {

    // The container that will house each of the dropdowns
    const modalDdContainer = $(`#modal-dropdown-container-id`);

    for(let i = 0; i < numMaps; i++) {

        const ddContainer = $(`<div class="dropdown fwe-dropdown-container"></div>`);

        const ddContainerBtn = $(`<button class="btn btn-outline-light dropdown-toggle dropdown-btn-style" ` +
                `type="button" ` +
                `id="map${i}-raster-btn-id" ` + 
                `data-bs-toggle="dropdown" ` + 
                `aria-expanded="false">` + 
            `</button>`)

        const selectedLayer = rasterLayers[i]

        const ddContainerBtnSelected = $(`<span id="map${i}-selected-raster-id">Map ${i+1} : ${selectedLayer.layerName}</span>`);

        ddContainerBtn.append(ddContainerBtnSelected);
        ddContainer.append(ddContainerBtn);

        // Generate each of the dropdown options
        const listContainer = $(`<ul class="dropdown-menu dropdown-menu-style"></ul>`);
        
        rasterLayers.forEach(function(layer, index) {
            const liId = layer.layerName.replace(" ", "-").toLocaleLowerCase()
            const li = $(`<li><a class="dropdown-item" ` + 
                `value="${layer.layerValue}" ` + 
                `id="dd-${i}-${liId}-id">${layer.layerName}</a></li>`);
            
            // Handle the on-click behaviour for this particular dropdown option
            li.on("click", function() {
                const newDropdownTextValue = `Map ${i+1} : ${layer.layerName}`
                ddContainerBtnSelected.html(newDropdownTextValue);
                
                // Change the layer that's currently shown on the map
                let mapN = getMap(i);
                mapN.removeAll();
                mapN.add(createWmsLayer(layer.layerName));

                // load the new legend
                loadLegendHTML(layer, i+1);

                // Replace the map cell header
                let mapNView = getMapView(i);
                setMapHeaderValues(layer, mapNView.timeExtent.end, i);
            })

            listContainer.append(li);
        });

        ddContainer.append(listContainer);

        // Append the entire thing to the modal container
        modalDdContainer.append(ddContainer);

        // Attach the dropdown listener to the button
        ddContainerBtn.on("click", function(e) {
            e.stopPropagation();
            // Toggle dropdown if not already visible
            if(listContainer) {
                ddContainerBtn.dropdown('toggle');
            }
        });
    }
}

function incidentsLayerRefreshLoop() {
    getIncidents();
    setTimeout(incidentsLayerRefreshLoop, 
            incidentRefreshTimeout);
}

/**
 * Attaches the listener to the relevant footer buttons
 */
function attachFooterButtonListener() {
    
    $('#btnSettings').on('click', function() {
        $('#brief-settings-modal-id').modal('show');
    });

    $('#btnIncidents').on('click', function() {
        if($(this).hasClass('brief-button-style-on')) {
            // Remove the incidents from all 4 maps
            clearIncidents();
            $(this).removeClass('brief-button-style-on');
            $(this).addClass('brief-button-style');
        } else {
            // Add the incidents to all 4 maps
            showIncidents();
            $(this).removeClass('brief-button-style');
            $(this).addClass('brief-button-style-on')
        }
        
    })
}

/**
 * Rounds a given date to the nearest hour
 * @param {*} date 
 * @returns 
 */
function roundToNearestHour(date) {
    const roundedDate = new Date(date); // Create a copy of the original date
    roundedDate.setMinutes(0); // Set minutes to 0 to round to the nearest hour
    roundedDate.setSeconds(0); // Set seconds to 0 for consistency
    roundedDate.setMilliseconds(0); // Set milliseconds to 0 for consistency

    // If the minutes are between 30 and 59, round to the next hour
    if (date.getMinutes() >= 30) {
        roundedDate.setHours(roundedDate.getHours() + 1);
    }

    return roundedDate;
}

/**
 * Removes the incidents layer from each of the ESRI maps
 */
function clearIncidents() {
    for(let i = 0; i < numMaps; i++) {
        const mapN = getMap(i);
        const incidN = getIncidentGraphicsLayer(i);
        mapN.remove(incidN);
    }
}

function generateLegendItem(colour, label) {
    const legendContainer = $(`<div class="legend-item-container"></div>`);
    const legendSquare = $(`<div style="background-color: ${colour}" class="legend-item-style"></div>`);
    const legendLabel = $(`<div class="legend-item-label">${label}</div>`);

    legendContainer.append(legendSquare);
    legendContainer.append(legendLabel);

    return legendContainer;
}

function loadLegendHTML(rasterLayer, layerIndex) {
    const legendContainer = $(`#map${layerIndex}Legend`);

    const params = new URLSearchParams({
        request: 'GetLegendGraphic',
        service: 'WMS',
        version: '1.1.1',
        layer: `fireweather:${rasterLayer.layerValue}`,
        format: 'application/json'
    });

    $.ajax({
        url: GEOSERVER_URL,
        method: "GET",
        data: params.toString(),
        success: function(response) {
            const colourMapEntries = response['Legend'][0]['rules'][0]['symbolizers'][0]['Raster']['colormap']['entries'];
            
            // Clear the legend
            legendContainer.html('');
            
            for(let i = 0; i < colourMapEntries.length; i++) {
                const entry = colourMapEntries[i];
                if(entry['label'] === 'nodata') continue;
                const legendItem = generateLegendItem(entry['color'], entry['label']);
                legendContainer.append(legendItem);
            }
        },
        error: function(xhr, status, error) {
            console.error("Error:", error);
            // Handle error here
        }
    })
}

function showIncidents() {
    for(let i = 0; i < numMaps; i++) {
        const mapN = getMap(i);
        const incidN = getIncidentGraphicsLayer(i);
        mapN.add(incidN);
    }
}

function getIncidents() {
    $.ajax({
        url: "https://utility.arcgis.com/sharing/rss?url=http://www.rfs.nsw.gov.au/feeds/majorIncidents.xml&outSR=",
        method: "GET",
        dataType: "json",
        success: function(response) {
            // Remove the graphics from the maps

            for(let i = 0; i < numMaps; i++) {
                const incidN = getIncidentGraphicsLayer(i);
                incidN.graphics.removeAll();
            }

            // Response is already parsed as JSON if the server returned JSON
            response['featureCollection']['layers'].map(function(layer) {
                if(layer['name'] === 'Points') {
                    layer['featureSet']['features'].map(function(feature) {
                        // Determine what icon this should correspond to
                        const incidentCategory = feature['attributes']['category'];
                        let iconUrl;
                        switch(incidentCategory) {
                            case 'Advice':
                                iconUrl = 'img/dispatch/Advice.png'
                                break;
                            case 'Planned Burn':
                                iconUrl = 'img/dispatch/FireIncidentConfirmed.png'
                                break;
                            case 'Not Applicable':
                                iconUrl = 'img/dispatch/NotApplicable.png'
                                break;
                            default: 
                                console.error(`Unknown incident category : ${incidentCategory}`)
                        }
        
                        let incidentStatus = "";
                        try {
                            //Pulls the value of Status from the description field
                            incidentStatus = feature['attributes']['description'].split('<br />')[3].split(': ')[1].trim();
                        }
                        catch (error) {
                            console.log(error)
                        }
                        if (incidentStatus == "Responding") {
                            //iconUrl = 'img/dispatch/FireAppliance.png';
                            iconUrl = 'img/dispatch/Responding.png';
                        }

                        const geometryPoint = new Point({
                            x: feature['geometry']['x'],
                            y: feature['geometry']['y']
                        })

                        // Create the icon
                        const newSymbol = new PictureMarkerSymbol({
                            url: iconUrl,
                            width: "30px",
                            height: "30px",
                        });

                        for(let i = 0; i < numMaps; i++) {
                            const incidN = getIncidentGraphicsLayer(i);
                            incidN.graphics.add(new Graphic({
                                symbol: newSymbol,
                                geometry: geometryPoint,
                                popupTemplate: popupTemplate,
                                attributes: feature['attributes']
                            }))
                        }
                    })
                }


            });
            // Now you can work with the JSON response object here
        },
        error: function(xhr, status, error) {
            console.error("Error:", error);
            // Handle error here
        }
    });
}

/**
 * Extracts the timestamps for each of the layers returned from a 
 * GetCapabilities request.
 * 
 * The document should have the following structure:
 * WMS_Capabilities > Capabilities > Layer
 * 
 * Timesteps should be under the layer
 * @param {*} xmlDoc 
 */
function extractTimesteps(xmlDoc) {
    const xmlLayers = xmlDoc.getElementsByTagName("Layer");

    // Array containing the relevant layers we care about
    const relevantLayers = [];

    for(let i = 0; i < rasterLayers.length; i++) {
        const tgtLayerName = rasterLayers[i].layerValue;
        
        for(let i = 0; i < xmlLayers.length; i++) {
            const xmlLayer = xmlLayers[i];
    
            const name = xmlLayer.getElementsByTagName('Name');

            if(name[0].innerHTML === tgtLayerName) {
                // ! This has been left to allow for the debugging of
                // ! the XML document if the format changes in the future
                // console.log(xmlLayer);
                relevantLayers.push(xmlLayer);
                break;
            }
        }
    }

    // Go through each of the relevant layers and extract the timestamps
    for(let i = 0; i < relevantLayers.length; i++) {
        const relevantLayer = relevantLayers[i];
        const timesteps = [];

        const dimensions = relevantLayer.getElementsByTagName('Dimension');
        for(let j = 0; j < dimensions.length; j++) {
            const dim = dimensions[j];
            if(dim.getAttribute('name') === 'time') {
                // ! This has been left to allow for the debugging of
                // ! the XML document if the format changes in the future
                // console.log(dim.innerHTML);
                const timestampStrings = dim.innerHTML.split(",");
                for(let k = 0; k < timestampStrings.length; k++) {
                    timesteps.push(new Date(timestampStrings[k]));
                }
                break;
            }
        }

        // Determine whether this is a daily or hourly layer
        const step1 = roundToNearestHour(new Date(timesteps[0]));
        const step2 = roundToNearestHour(new Date(timesteps[1]));

        const timeDelta = ((step2 - step1) / (1000 * 60 * 60));

        // Save this data
        const rasterLayer = rasterLayers.find(
                layer => layer.layerValue === relevantLayer.getElementsByTagName('Name')[0].innerHTML);
        rasterLayer.timeSteps = timesteps;

        switch(timeDelta) {
            case 1:
                rasterLayer.timeStepInterval = "hourly";
                break;
            case 3:
                rasterLayer.timeStepInterval = "3-hourly";
                break;
            case 24:
                rasterLayer.timeStepInterval = "daily";
                break;
        }
    }
}

function getClosestTimeStep(timesliderDate, datesArray) {
    const differenceArray = [];
    for(let i = 0; i < datesArray.length; i++) {
        differenceArray.push(Math.abs(timesliderDate - datesArray[i]));
    }

    const minDiff = Math.min(...differenceArray);
    const minDiffIndex = differenceArray.indexOf(minDiff);
    const closestTimestep = datesArray[minDiffIndex];

    return closestTimestep;
}

/**
 * 
 */
function setMapTimeStep(index, timesliderDate) {
    const irrelevantLayers = ['streets-vector-base-layer'];
    let selectedMap;
    let selectedMapView;
    switch(index) {
        case 0:
            selectedMap = map1;
            selectedMapView = map1View;
            break;
        case 1:
            selectedMap = map2;
            selectedMapView = map2View;
            break;
        case 2:
            selectedMap = map3;
            selectedMapView = map3View;
            break;
        case 3:
            selectedMap = map4;
            selectedMapView = map4View;
            break;
        default:
            console.error(`Unknown set map time step index : ${index}`);
            return;
    }

    // Find the map that's selected
    for (const layer of selectedMap.allLayers){
        // do something with each view graphic
        if(irrelevantLayers.includes(layer.id)) continue;
        
        // Get the timesteps for this layer
        const rasterLayer = rasterLayers.find(
                e => e.layerValue === layer.id);
        
        if(!rasterLayer) continue;

        // Set the closest timestep
        const closestTimestep = getClosestTimeStep(
                timesliderDate, rasterLayer.timeSteps);
        
        // Set the header for the map
        setMapHeaderValues(rasterLayer, closestTimestep, index);

        selectedMapView.timeExtent = new TimeExtent({
            start: new Date(closestTimestep),
            end: new Date(closestTimestep)
        });
        break;
    }
}

/**
 * For more information about how this is configured, check here:
 * https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-TimeSlider.html#properties-summary
 */
async function generateTimeslider() {
    // Determine what timeslider to default to and their extent

    const params = new URLSearchParams({
        request: 'GetCapabilities',
        service: 'WMS',
        version: '1.3.0', // or the version supported by your WMS service
        // Optionally, you can add other parameters like:
        // layers: 'comma-separated-list-of-layers',
        layers: `fireweather:${rasterLayers[0].layerValue}`,
        query_layers: `fireweather:${rasterLayers[0].layerValue}`,
        // styles: 'comma-separated-list-of-styles',
        // crs: 'EPSG:4326', // Coordinate Reference System
        // format: 'image/png', // Output image format
        // ...
    });

    $.ajax({
        url: GEOSERVER_URL,
        method: 'GET',
        data: params.toString(),
        success: function(response) {
            // ! This has been left to allow for the debugging of
            // ! the XML document if the format changes in the future
            // const xmlString = new XMLSerializer().serializeToString(response);
            // console.log(xmlString)
            
            extractTimesteps(response);

            // Get the earliest start
            let startDate = null;
            let endDate = null;

            for(let i = 0; i < rasterLayers.length; i++) {
                const rasterLayer = rasterLayers[i];
                const minDate = new Date(Math.min(...rasterLayer.timeSteps.map(date => date.getTime())));
                const maxDate = new Date(Math.max(...rasterLayer.timeSteps.map(date => date.getTime())));

                if(!startDate || minDate < startDate) startDate = minDate;
                if(!endDate || maxDate > endDate) endDate = maxDate;
            }

            timeSlider = new TimeSlider({
                container: "timeslider-id",
                fullTimeExtent: {
                  start: startDate,
                  end: endDate
                },
                stops: {
                    interval: {
                      value: 1,
                      unit: "hours"
                    }
                },
                mode: "cumulative-from-start",
                layout: "wide",
            });
            
            let sliderDebouncer;

            // Watch the timeslider time extent
            reactiveUtils.watch(
                // `timeExtent` is the property that holds the current
                // positions of the 'thumbs' for the timeslider.
                // Since we're using a mode that has only one thumb, we
                // only need the `end` value.
                () => timeSlider.timeExtent,
                (value) => {
                  // update layer view filter to reflect current timeExtent
                  clearTimeout(sliderDebouncer);

                  // Timeout to prevent sending off hundreds of requests
                  // when moving the timeslider in hourly mode
                  sliderDebouncer = setTimeout(() => {
                    
                    // Apply this to all of the maps
                    setMapTimeStep(0, value.end);
                    setMapTimeStep(1, value.end);
                    setMapTimeStep(2, value.end);
                    setMapTimeStep(3, value.end);

                  }, 250);
                }
            );

            // Set the default header values
            for(let i = 0; i < numMaps; i++) {
                const rasterLayer = rasterLayers[i];

                setMapHeaderValues(rasterLayer, rasterLayer.timeSteps[0], i);
            }
        },
        error: function(xhr, status, error) {
            console.error(xhr, status, error);
        }
    }) 
}

/**
 * Mirrors the drags from any given map onto the other maps
 */
function attachEsriDragMirrors() {
    
    let opts = {
        duration: 50  // Duration of animation will be 1 second(s)
    };

    const maps = [map1View, map2View, map3View, map4View];
    let timeHandle1, timeHandle2, timeHandle3, timeHandle4;
    function getTimeHandle(index) {
        switch(index) {
            case 0:
                return timeHandle1;
            case 1:
                return timeHandle2;
            case 2:
                return timeHandle3;
            case 3:
                return timeHandle4;
            default:
                console.error(`Unknown time handle index : ${index}`);
        }
    }
    
    /**
     * Handles the application of the current maps movements
     * to all the other maps
     * @param {*} map1 
     * @param {*} map2 
     * @param {*} index1 
     * @param {*} index2 
     */
    function handleMirror(mapX, index, maps) {
        let handle = getTimeHandle(index);
        clearTimeout(handle);
        handle = setTimeout(
            () => {
                maps.forEach(function(mapY, index2) {
                    if(index2 != index) {
                        mapY.goTo({
                            center: [
                                mapX.center.longitude,
                                mapX.center.latitude
                            ],
                            zoom: mapX.zoom
                        }, opts);
                    }
                });
            }, 100
        );
        
    }

    // Attach drag and zoom event handlers to each map
    maps.forEach(function(mapX, index) {
        mapX.on("drag", function(event) {
            if (event.action === 'update' ||
                event.action === 'end') {
                handleMirror(mapX, index, maps);
            }
        });

        mapX.on("mouse-wheel", function(event) {
            handleMirror(mapX, index, maps);
            // Do another transition after 1 second
            setTimeout(() => handleMirror(mapX, index, maps), 1000)
        })
    });

    // Attach zoom event handlers for the widget buttons
    maps.forEach(function(mapX, index) {
        // Only attach listeners to the buttons when the view has loaded completely
        mapX.when(function() {
            const uiContainer = mapX.ui.container;
            const zoomBtns = uiContainer.getElementsByTagName('calcite-button');

            for (let zoomBtn of zoomBtns) {
                zoomBtn.addEventListener("click", function() {
                    setTimeout(() => handleMirror(mapX, index, maps), 250);
                })
            }
        });
    });
}

/**
 * Loads the ESRI map views into the map containers
 */
async function attachEsriMaps() {
    
    const mapCenter = [151.209, -33.865]; // Longitude, latitude
    const defaultZoom = 5;
    
    function attachEsriMap(containerId, layerName) {
        // Get the sublayers
        const layerObj = createWmsLayer(layerName);

        const map = new Map({
            basemap: 'streets',
            layers: [layerObj]
        });
    
        const view = new MapView({
            map: map,
            zoom: defaultZoom,
            container: containerId,
            center: mapCenter,
            navigation: {
                momentumEnabled: false,
            }
        });

        view.constraints = {
            rotationEnabled: false
        };

        return {
            mapX: map,
            viewX: view
        }
    }

    const out1 = attachEsriMap('map1', rasterLayers[0].layerName);
    loadLegendHTML(rasterLayers[0], 1);
    map1 = out1.mapX;
    map1View = out1.viewX;
    incid1 = new GraphicsLayer();

    const out2 = attachEsriMap('map2', rasterLayers[1].layerName);
    loadLegendHTML(rasterLayers[1], 2);
    map2 = out2.mapX;
    map2View = out2.viewX;
    incid2 = new GraphicsLayer();
    
    const out3 = attachEsriMap('map3', rasterLayers[2].layerName);
    loadLegendHTML(rasterLayers[2], 3);
    map3 = out3.mapX;
    map3View = out3.viewX;
    incid3 = new GraphicsLayer();

    const out4 = attachEsriMap('map4', rasterLayers[3].layerName);
    loadLegendHTML(rasterLayers[3], 4);
    map4 = out4.mapX;
    map4View = out4.viewX;
    incid4 = new GraphicsLayer();
}

$(window).on("load", function() {
    generateModalDropdowns();

    // Load in the navbar dynamically (this is 
    // how we reuse components in ancient times)
    $("#fwv-navbar-id").load("navbar.html", function() {
        attachDropdownListeners();
    });
    
    // LayerManager.initLayers(function() {
        
    // });

    attachEsriMaps();
    attachEsriDragMirrors();
    generateTimeslider();
    attachFooterButtonListener();
    attachModalBtnListeners();
    incidentsLayerRefreshLoop();
});